import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ExpandSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.7021 9.8942L16.7021 3.29792L10.1059 3.29792'
      stroke='#A3ADB7'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    ></path>
    <path
      d='M3.29834 10.1056L3.29834 16.7019L9.89462 16.7019'
      stroke='#A3ADB7'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    ></path>
    <path
      d='M12.4998 6.99976L6.99977 12.9998'
      stroke='#A3ADB7'
      strokeWidth='1.5'
      strokeLinecap='round'
    ></path>
  </svg>
);

export const ExpandIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ExpandSvg} {...props} />
);
